import { Button } from '@sweep-io/sweep-design';
import { ColorSwatch } from './ColorSwatch';
import { Box } from '@mui/material';

export const SmallColorSwatchButton = ({
  color,
  onClick,
  pressed,
}: {
  color: string;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  pressed: boolean;
}) => {
  return (
    <Box
      component="span"
      sx={{
        '& .MuiButtonBase-root': {
          paddingLeft: '8px !important',
          paddingRight: '8px !important',
        },
        '& .MuiButton-startIcon': {
          display:
            'none' /* TODO: Fix this in sweep design. The startIcon is appearing even tough it's not there. */,
        },
        '& .MuiButton-endIcon': {
          svg: {
            width: '12px !important',
            height: '12px !important',
          },
        },
      }}
    >
      <Button
        variant="squared"
        size="small"
        endIconName="ChevronDown"
        onClick={onClick}
        pressed={pressed}
      >
        <ColorSwatch color={color} size="small" />
      </Button>
    </Box>
  );
};
